<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-sm="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              ref="amount"
              name="amount"
              :label="$currencyLabel('مبلغ')"
              rules="required|fee"
              validation-container-class="col-12"
              input-class="form-control"
              v-model="dataForm.amount"
              :has-thousand-seprator="true"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="افزایش موجودی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    title: {},
  },
  data() {
    return {
      colWidth: "col-lg-12",
      dataForm: {},
      isLoading: false,
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
            this.isLoading = true
          this.$persistClient(
            "post",
            "payments",
            this.dataForm
          ).then((res) => {
              location.replace(res.data);
          })
          .finally(() => this.isLoading = false)
        }
      });
    },
    reset() {
      this.dataForm = {}
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
